module.exports = __webpack_public_path__ + "img/manutd2.1ce82ae8.jpg";